module.exports = __webpack_public_path__ + "img/12_wires_soldered.f5c1199e.jpg";